
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { DocType, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class DocTypeEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    docType: DocType;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getDocType()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getDocType(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.docType = data;
                this.onDataChanged.next(this.docType);
                resolve(this.docType);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('doctype/' + this.routeParams.id).subscribe({next:(res: DocType ) => {
                    this.docType = res;
                    this.onDataChanged.next(this.docType);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(docType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('doctype/', docType).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    edit(docType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('doctype/', docType).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(docType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('doctype/' + docType.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): DocType {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
